import Reaptcha from 'reaptcha';
import { useEffect, useRef } from 'react';
import { useRecaptchaScript } from 'typescript/apps/checkout_v3/components/recaptcha/use_recaptcha_script';

export const RECAPTCHA_TEST_ID = 'recaptcha-test-id';

/**
 * this is a workaround for now since the Reaptcha component does not have
 * the correct typing for typescript and it just yells at us
 * for now we'll just repexport the Reaptcha component from a JSX file and use it
 * as is until we can fix it
 */
const RecaptchaWorkaround = ({
  className = '',
  languageCode,
  siteKey,
  onLoad = () => {},
  onVerify,
  onExpire = () => {},
  onError = () => {},
  ...props
}) => {
  const { recaptchaLoaded, recaptchaError } = useRecaptchaScript();

  // need to store the callbacks in refs since the rerenderes can cause an infinite loop
  const onErrorRef = useRef(onError);
  const onLoadRef = useRef(onLoad);

  // Handle script loading errors
  useEffect(() => {
    if (recaptchaError) {
      onErrorRef.current(recaptchaError);
    }
  }, [recaptchaError]);

  // Call onLoad when script is successfully loaded
  useEffect(() => {
    if (recaptchaLoaded) {
      onLoadRef.current();
    }
  }, [recaptchaLoaded]);

  // Don't render the Reaptcha component until the script is loaded
  if (!recaptchaLoaded) {
    return null;
  }

  return (
    <Reaptcha
      data-testid={RECAPTCHA_TEST_ID}
      className={className}
      hl={languageCode}
      sitekey={siteKey}
      onVerify={onVerify}
      onExpire={onExpire}
      onError={onError}
      inject={false}
      {...props}
    />
  );
};

export default RecaptchaWorkaround;
